/**
 * Money and quantities on screen, Spanish, from strings.
 *
 * **Never a `number` in the middle.** The API sends decimals as strings precisely so their
 * scale survives, and `0.1 + 0.2` is not `0.3` in binary floating point. The front formats
 * and displays; the arithmetic belongs to the API, which uses `Decimal`. A quote a cent out
 * is a quote somebody has to explain to a customer.
 *
 * `money`, `unitPrice`, `percent`, `editableNumber` and `decimalFor` live in
 * `shared/utils/money.ts` since the tariffs (contract v10.48) print and edit the same
 * figures; they are re-exported here for the quotes.
 */
import { percent } from '@/shared/utils/money';

export { decimalFor, editableNumber, money, percent, unitPrice } from '@/shared/utils/money';

/**
 * The discounts of a line, as the supplier wrote them and **in order**.
 *
 * In order and joined with `+` rather than added up: 30 % and 10 % chain to 37 %, not
 * 40 %, and showing "40 %" would be showing a number that appears nowhere.
 */
export function discounts(values: string[] | null | undefined): string {
  if (!values || values.length === 0) return '—';
  return values.map((each) => percent(each)).join(' + ');
}

/** What the supplier's price is per: `1` shows nothing, the rest say so. */
export function basis(value: number | undefined): string {
  return !value || value === 1 ? '' : ` / ${value} ud`;
}
